import React from 'react';
import { FieldPathByValue, UseFormReturn } from 'react-hook-form';
import { CardBody, CardHeader, CardTitle } from '@progress/kendo-react-layout';
import SubjectProfileDetailsConfigurationCheckboxList from './checkbox-list';
import Card from '@components-clean/core/card';
import { useTranslation } from '@hooks/index';
import { SubjectProfileDetailsConfigurationFormValues } from './types';

type CheckboxKey = FieldPathByValue<
    Exclude<SubjectProfileDetailsConfigurationFormValues['subjectStatus'], null>,
    boolean | null
>;

const checkboxKeys: CheckboxKey[] = [
    'numberOfAEs',
    'numberOfSAEs',
    'numberOfAESIs',
    'numberOfPDs',
    'numberOfQueriesOpenAll',
    'combiVisits',
    'combiAssessments',
];

type Props = {
    control: UseFormReturn<SubjectProfileDetailsConfigurationFormValues>['control'];
    disabled: boolean;
};

const MiniWidgetsCard = ({ control, disabled }: Props) => {
    const { t } = useTranslation('admin', {
        keyPrefix: 'subjectConfig.subjectProfileDetailsConfig.subjectStatus',
    });

    return (
        <Card padding="none" data-testid="subject-profile-details-configuration-mini-widgets">
            <CardHeader>
                <CardTitle>{t('miniWidgets')}</CardTitle>
            </CardHeader>

            <CardBody>
                <SubjectProfileDetailsConfigurationCheckboxList
                    control={control}
                    disabled={disabled}
                    checkboxKeys={checkboxKeys.map((key) => ({
                        key: `subjectStatus.${key}`,
                        label: t(`field.${key}`),
                    }))}
                />
            </CardBody>
        </Card>
    );
};

export default MiniWidgetsCard;
